export default "__VITE_ASSET__D1_gP1xK__"